<template>
  <div :class="[...containerClasses, 'wf-absolute', 'wf-right-0']" :style="containerStyles">
    <ul :class="classes" :style="styles" class="wf-w-40">
      <li v-for="(child, index) in children" :key="index">
        <span v-text="child.text"></span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      classes: {
        type: [String, Array],
        required: true
      },
      containerClasses: {
        type: [String, Array],
        required: true
      },
      styles: {
        type: [String, Object],
        required: true
      },
      containerStyles: {
        type: [String, Object],
        required: true
      },
      children: {
        type: Array,
        required: true
      }
    }
  }
</script>